export class DisconnectDto {
    constructor(public ConnectionId: number, public ClientId: string, public ClientSecret: string) {
    }
}